import HttpService from './baseHttp'
// 基础数据

// 通过仓库id，获取仓库地址信息
export const HttpVoteNoInboundList = (data = {}, config) => HttpService.get('/api/v2/voteNoInbound/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpVoteNoInboundExport = (data = {}, config) => HttpService.get('/api/v2/voteNoInbound/export', { params: data,...config,baseURL: process.env.VUE_APP_APIURL_FBB })

// 通过仓库id，获取仓库地址信息
export const HttpNotOnShelfReportList = (data = {}, config) => HttpService.get('/api/v2/notOnShelfReport/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpNotOnShelfReportExport = (data = {}, config) => HttpService.get('/api/v2/notOnShelfReport/export', { params: data,...config,baseURL: process.env.VUE_APP_APIURL_FBB })

// 仓储kpi看板与设置
export const HttpSaveStorageKpiSetting = (data = {}) => HttpService.post('/api/v2/warehouseKpiTarget/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetStorageKpiSetting = (data = {}) => HttpService.get('/api/v2/warehouseKpiTarget/findByOrg', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


// 库容预测维护
// 列表，查看，保存，删除，组织下有效的区域下拉
export const HttpCapacityList = (data = {}, config) => HttpService.get('/api/v2/capacityPredict/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetCapacityOne = (data = {}, config) => HttpService.get('/api/v2/capacityPredict/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpSaveCapacityOne = (data = {}) => HttpService.post('/api/v2/capacityPredict/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpDeleteCapacityOne = (data = {}, config) => HttpService.get('/api/v2/capacityPredict/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetAreaList = (data = {}, config) => HttpService.get('/api/v2/areaManage/findManageOrgArea', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 请求bi报表数据
export const HttpGetChartData = (data = {}) => HttpService.get('/api/v1/ReportTask/getComponentApiData', { params: data, baseURL: process.env.VUE_APP_APIURL_BI });














